class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    const input = this.querySelector('input[name="discount"]');
    const button = this.querySelector('[data-update-coupon]');
    if (!input || !button) return;
    this.initialized = true;
    this.input = input;
    this.button = button;
    this.status = document.createElement('p');
    this.status.className = 'stockka-promo-status';
    this.status.setAttribute('role', 'status');
    this.status.setAttribute('aria-live', 'polite');
    this.status.style.cssText = 'flex-basis:100%;width:100%;margin:8px 0 0;font-size:14px;line-height:1.5;';
    this.appendChild(this.status);
    this.style.flexWrap = 'wrap';
    button.addEventListener('click', event => { event.preventDefault(); this.applyCode(); });
    input.addEventListener('input', () => {
      input.removeAttribute('aria-invalid');
      this.removeAttribute('data-code-applied');
      this.status.textContent = '';
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); this.applyCode(); }
    });
    this.restoreAppliedCode();
  }

  discountApplications(cart) {
    return [
      ...(cart.cart_level_discount_applications || []),
      ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(value => value.discount_application))
    ].filter(Boolean);
  }

  showAppliedCode(code, cart) {
    const discount = this.discountApplications(cart).find(item =>
      item.type === 'discount_code' && String(item.title).toUpperCase() === code.toUpperCase()
    );
    const percentage = discount?.value_type === 'percentage' ? Number(discount.value) : null;
    this.setAttribute('data-code-applied', 'true');
    this.input.removeAttribute('aria-invalid');
    this.status.textContent = '✓ ' + this.dataset.success +
      (percentage > 0 ? ' — ' + percentage + '%' : '');
  }

  async restoreAppliedCode() {
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (!this.isConnected || this.input.value.trim() || CouponCode.busy) return;
      const code = (cart.discount_codes || []).find(item => item.applicable)?.code ||
        this.discountApplications(cart).find(item => item.type === 'discount_code')?.title;
      if (code) {
        this.input.value = code;
        this.showAppliedCode(code, cart);
      }
    } catch (_) {}
  }

  async applyCode() {
    if (CouponCode.busy) return;
    const code = this.input.value.trim();
    this.input.removeAttribute('aria-invalid');
    this.removeAttribute('data-code-applied');
    if (!code) {
      this.status.textContent = this.dataset.empty;
      this.input.setAttribute('aria-invalid', 'true');
      return;
    }
    CouponCode.busy = true;
    this.button.disabled = true;
    this.input.readOnly = true;
    this.status.textContent = this.dataset.loading;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const beforeResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!beforeResponse.ok) throw new Error('cart');
      const before = await beforeResponse.json();
      if (!before.item_count) { this.status.textContent = this.dataset.emptyCart; return; }
      const existing = (before.discount_codes || []).filter(item => item.applicable).map(item => item.code);
      const codes = [...new Set([...existing, code].map(value => value.toUpperCase()))];
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      });
      if (!response.ok) throw new Error('discount');
      const cart = await response.json();
      const match = (cart.discount_codes || []).find(item => item.code.toUpperCase() === code.toUpperCase());
      const allocations = [
        ...(cart.cart_level_discount_applications || []),
        ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(value => value.discount_application))
      ];
      const allocated = allocations.some(item => item?.type === 'discount_code' && String(item.title).toUpperCase() === code.toUpperCase());
      if (!match?.applicable && !allocated) {
        this.status.textContent = this.dataset.invalid;
        this.input.setAttribute('aria-invalid', 'true');
        return;
      }
      this.input.removeAttribute('aria-invalid');
      this.showAppliedCode(code, cart);
      try { localStorage.setItem('storedDiscount', code); } catch (_) {}
      window.location.assign(root + 'cart');
    } catch (_) {
      this.status.textContent = this.dataset.error;
    } finally {
      CouponCode.busy = false;
      this.button.disabled = false;
      this.input.readOnly = false;
    }
  }
}

customElements.define('coupon-code', CouponCode);